/**
 * Canonical billing identity (audit P0.3).
 *
 * QA checklist — every customer-facing surface should match:
 * - Paid plan name: Pro (spoken/written as "DrillFlo Pro")
 * - Free plan name: Starter
 * - Trial length: 15 days (matches live Stripe Checkout)
 * - Starter: no credit card
 * - Pro trial: credit card required; $0 due today until trial ends
 */
export const BILLING = {
  paidPlanName: "Pro",
  paidPlanLabel: "DrillFlo Pro",
  starterPlanName: "Starter",
  trialDays: 15,
  monthlyPrice: 25,
  annualPrice: 250,
};
